export const events = {
  pageView: 'comet_page_view_event',
  event: 'comet_event',
};
